import { Box, HStack, Text } from '@chakra-ui/react'
import React from 'react'
import { Link, useMatch } from 'react-router-dom'

const SideBarFunctionButton = ({ name, icon, target, onClick }) => {
  return (
    <Box
      w="100%"
      px={5}
      py={3}
      _hover={{ bg: 'teal.600', cursor: 'pointer', color: 'white', borderRadius: '10' }}
      bg={''}
      color={''}
      borderRadius={''}
      onClick={onClick}
    >
      <HStack>
        {icon}
        <Text fontSize="md">{name}</Text>
      </HStack>
    </Box>
  )
}

export default SideBarFunctionButton
